import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Utils/axiosInstance";
import { toast } from "react-hot-toast";

const initialStaterating = {
    reviews: [], // Add new state for game ratings
    averageRating: null, // Add new state for game ratings
    ratingCounts: {}, // Add new state for game ratings
    totalReviews: null, // Add new state for game ratings
    success: false,
    message: '',
    // Individual loading states for each API call
    loadingStates: {
        getGameRatings: false,
        createrating: false,
        updaterating: false,
        deleterating: false,
    },
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const createrating = createAsyncThunk(
    "rating/createrating",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/addRating`, data);
            toast.success(response.data.message || "rating Add successful");
            return response.data;
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || "rating not successful");
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const updaterating = createAsyncThunk(
    "rating/updaterating",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/updateRating/${data._id}`, data);
            toast.success(response.data.message || "rating Update successful");
            return response.data; // Return the updated starring data
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || "rating not Update");
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleterating = createAsyncThunk(
    "rating/deleterating",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`/deleteRating/${data._id}`);
            toast.success(response.data.message || "rating Delete successful");
            if (response.data.success) {
                return data._id;
            }
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || "rating not Delete");
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getGameRatings = createAsyncThunk(
    "rating/getGameRatings",
    async (gameId, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/getGameRatings/${gameId}`);
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const ratingSlice = createSlice({
    name: 'rating',
    initialState: initialStaterating,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getGameRatings.pending, (state) => {
                state.loadingStates.getGameRatings = true;
                state.message = 'Fetching game ratings...';
            })
            .addCase(getGameRatings.fulfilled, (state, action) => {
                state.loadingStates.getGameRatings = false;
                state.success = true;
                state.message = 'Game ratings fetched successfully';
                state.reviews = action.payload.reviews;
                state.ratingCounts = action.payload.ratingCounts;
                state.averageRating =
                  action.payload.averageRating != null
                    ? Number(action.payload.averageRating)
                    : null;
                state.totalReviews =
                  action.payload.totalReviews != null
                    ? Number(action.payload.totalReviews)
                    : null;
            })
            .addCase(getGameRatings.rejected, (state, action) => {
                state.loadingStates.getGameRatings = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch game ratings';
            })

            .addCase(createrating.pending, (state) => {
                state.loadingStates.createrating = true;
                state.message = 'Creating rating...';
            })
            .addCase(createrating.fulfilled, (state, action) => {
                state.loadingStates.createrating = false;
                state.success = true;
                state.message = 'rating created successfully';
                state.reviews.push(action.payload.data);
            })
            .addCase(createrating.rejected, (state, action) => {
                state.loadingStates.createrating = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to create rating';
            })
            .addCase(updaterating.pending, (state) => {
                state.loadingStates.updaterating = true;
                state.message = 'Updating rating...';
            })
            .addCase(updaterating.fulfilled, (state, action) => {
                state.loadingStates.updaterating = false;
                state.success = true;
                state.message = 'rating update successfully';
                state.reviews = state.reviews.map((v) => v._id == action.payload.data._id ? action.payload.data : v);
            })
            .addCase(updaterating.rejected, (state, action) => {
                state.loadingStates.updaterating = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update rating';
            })
            .addCase(deleterating.pending, (state) => {
                state.loadingStates.deleterating = true;
                state.message = 'Deleting rating...';
            })
            .addCase(deleterating.fulfilled, (state, action) => {
                state.loadingStates.deleterating = false;
                state.success = true;
                state.message = 'rating delete successfully';
                // state.rating = state.rating.filter((v) => v._id !== action.payload);
                state.reviews = state.reviews.filter((v) => v._id !== action.payload);
            })
            .addCase(deleterating.rejected, (state, action) => {
                state.loadingStates.deleterating = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete rating';
            })

    }
});

export default ratingSlice.reducer;